// 新聞 分享
import { useState, useEffect } from 'react';
import useCopy from '@/hook/useCopy';
import newsClient from '@/common/apiClient/newsClient';

import Image from 'next/image';
import { SHARE_LINK } from '@/common/constant';

const NewsShare = ({ location = '', newsId }) => {
    const copy = useCopy();

    // 是否為進度條
    const isProgress = location === 'progress';

    // 當前路徑
    const [currentPath, setCurrentPath] = useState('');

    // 分享
    const onShare = async (media) => {
        try {
            await newsClient.shareNews({ newsId, media });
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') setCurrentPath(window.location.href);
    }, []);

    return (
        <div className="flex items-center gap-x-[16px]">
            {!isProgress && (
                <span className="text-btn1 pr-[10px] text-white flex-shrink-0">分享</span>
            )}

            <div className="between-center gap-x-[16px] [&>*]:img-box [&>*]:w-[35px] [&>*]:h-[35px] [&>*]:relative [&_img]:trans [&_img]:absolute [&_img]:top-0">
                {SHARE_LINK.map((link, i) => {
                    // 複製連結
                    if (link.title === 'copy')
                        return (
                            <button
                                onClick={() => {
                                    copy(currentPath);
                                    onShare('copy');
                                }}
                                key={'news-share' + i + link.title}
                                className="group gtm-btn-copy"
                            >
                                <Image
                                    className="opacity-0 group-hover:opacity-[1]"
                                    width={35}
                                    height={35}
                                    src={`/images/social/icon_white_${link.title}.svg`}
                                    alt="icon"
                                />
                                <Image
                                    className="group-hover:opacity-0"
                                    width={35}
                                    height={35}
                                    src={
                                        isProgress
                                            ? `/images/social/icon_grey_${link.title}.svg`
                                            : `/images/social/icon_plum_${link.title}.svg`
                                    }
                                    alt="icon"
                                />
                            </button>
                        );

                    // 跳轉連結
                    return (
                        <a
                            key={'news-share' + i + link.title}
                            href={link.link + currentPath}
                            target="_blank"
                            rel="noreferrer noopener"
                            className="group"
                            onClick={() => onShare(link.title)}
                        >
                            <Image
                                className="opacity-0 group-hover:opacity-[1]"
                                width={35}
                                height={35}
                                src={`/images/social/icon_white_${link.title}.svg`}
                                alt="icon"
                            />
                            <Image
                                className="group-hover:opacity-0"
                                width={35}
                                height={35}
                                src={
                                    location === 'progress'
                                        ? `/images/social/icon_grey_${link.title}.svg`
                                        : `/images/social/icon_plum_${link.title}.svg`
                                }
                                alt="icon"
                            />
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default NewsShare;
